import { Button, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect, useState } from "react";
import ProvisionPopup from "components/join/provision-popup";
import { rem } from "assets/js/common";
import { setBottomColor } from "assets/js/apphandle";

const useStyles = makeStyles(theme => ({
  footer: {
    "& .main-footer": {
      padding: `${rem(40)} ${rem(25)} ${rem(70)}`,
      "& .logo": {
        fontSize: rem(14),
        fontWeight: 800,
        lineHeight: rem(18),
        letterSpacing: "-0.3px",
      },
      "& .addr": {
        margin: `${rem(8)} 0 ${rem(18)}`,
        "& li": {
          fontSize: rem(12),
          lineHeight: rem(18),
        },
      },
      "& .MuiButton-root": {
        fontSize: rem(13),
        fontWeight: 800,
        minWidth: "auto",
        lineHeight: rem(20),
        textDecoration: "underline",
        textUnderlinePosition: "under",
        "& + .MuiButton-root": {
          marginLeft: rem(15),
        },
      },
    },
  },
}));

export default function Footer(props) {
  const classes = useStyles();
  // popup
  const [tp, setTp] = useState("");
  const { open, handlePopupOpen, handlePopupClose } = props;

  const handlePopup = (e, tp) => {
    e.preventDefault();
    setTp(tp);
    handlePopupOpen();
  };

  useEffect(() => {
    if (open === true) setBottomColor("FFFFFF");
    else setBottomColor("F1270B");
  }, [open]);

  return (
    <div className={classes.footer}>
      <Divider className="divider-type-2" />
      <div className="main-footer">
        <div className="logo">㈜메가마트</div>
        <ul className="addr">
          <li>대표이사 : 서창헌, 신동익</li>
          <li>사업자등록번호 : 119-81-00851</li>
          <li>주소 : 서울시 금천구 시흥대로27길 32</li>
        </ul>

        <Button onClick={e => handlePopup(e, 2)} style={{ fontWeight: 400 }}>
          이용 약관
        </Button>
        <Button onClick={e => handlePopup(e, 3)}>개인정보처리방침</Button>
        <Button onClick={e => handlePopup(e, 4)}>영상정보처리기기운영·관리방침</Button>
        <ProvisionPopup open={open} tp={tp} handlePopupClose={handlePopupClose} />
      </div>
    </div>
  );
}
